import styled from "@emotion/styled";
import { Stack } from "react-bootstrap";
import { isSafari } from "react-device-detect";
import { IStyledComponentProps } from "../../../../theme/theme.types";
import { EPhaseStates } from "../../../../shared/enums/phases.enums";

const PhaseListItem = styled(Stack)<IStyledComponentProps>`
  &.phase-list-item {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grays.tertiary};
    margin: 0 16px;
    min-height: 42px;
    padding: 8px 0;

    .phase-icon-container {
      .phase-icon {
        font-size: 24px;
      }

      &.${EPhaseStates.COMPLETE} {
        margin-right: 8px;
      }

      span {
        bottom: 2px;
        font-size: ${({ theme }) => theme.fontSizes.smallest}px;
        left: -0.98rem;
        position: relative;
        width: 20px;
      }
    }

    .phase-name-cell {
      min-width: ${isSafari ? 184 : 162}px;
      &.${EPhaseStates.ACTIVE} {
        font-family: ${({ theme }) => theme.fontFamilies.semiBold};
      }

      span {
        text-decoration: underline dotted
          ${({ theme }) => theme.colors.brand.primary};
        text-underline-offset: 6px;

        @media (max-width: ${(props) =>
            props.theme.utils.getThemeBreakpoint("tablet")}) {
          text-underline-offset: 4px;
        }
      }

      @media (min-width: ${(props) =>
          props.theme.utils.getThemeBreakpoint("tablet")}) {
        &:hover {
          cursor: pointer;
        }
      }
    }

    // Note: Need to keep this around, since we need to use
    // bootstraps badge component when there are tool-tips needed
    .badge {
      border-radius: 0;
      width: 72px;
      font-size: 11px;
      font-family: ${({ theme }) => theme.fontFamilies.semiBold};
      padding: 6px 0;

      @media (min-width: ${(props) =>
          props.theme.utils.getThemeBreakpoint("tablet")}) {
        &.badge-tooltip {
          &:hover {
            cursor: pointer;
          }
        }
      }
    }

    &.${EPhaseStates.PENDING} {
      .phase-icon-container {
        color: lightgrey !important;
        .phase-icon {
          font-size: 24px;
          color: lightgrey !important;
        }
      }
    }

    &:last-child {
      border-bottom: 0 none;
    }

    @media (max-width: ${(props) =>
        props.theme.utils.getThemeBreakpoint("tablet")}) {
      margin: 0;
      .phase-date-cell {
        font-size: ${({ theme }) => theme.fontSizes.smallest}px;
      }
    }
  }
`;

export default { PhaseListItem };
